import * as React from 'react';
import { Button, OnboardingTooltip } from '@cian/ui-kit';
import { MaskedInput } from '../MaskedInput';

import * as styles from './styles.css';

export interface IMobileAuthForm {
  error?: string;
  phone: string;
  loading: boolean;
  submitPhone(): void;
  setPhone(phone: string): void;
  setOpen(open: boolean): void;
}

export const MobileAuthForm: React.FC<IMobileAuthForm> = ({
  error,
  loading,
  phone,
  submitPhone,
  setPhone,
  setOpen,
}) => {
  const [openTooltip, setOpenTooltip] = React.useState<boolean>(true);

  const openModal = React.useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const closeTooltip = React.useCallback(() => {
    setOpenTooltip(false);
  }, [setOpenTooltip]);

  const handleFocus = React.useCallback(() => {
    setOpenTooltip(false);
  }, [setOpenTooltip]);

  return (
    <div className={styles['container']}>
      <div className={styles['form']}>
        <h3 className={styles['title']}>Получите персональные условия&nbsp;от&nbsp;7&nbsp;банков</h3>
        <div className={styles['content']}>Ставки и анкета будут храниться в&nbsp;личном&nbsp;кабинете</div>
        <div className={styles['input']}>
          <MaskedInput size="small" value={phone} invalid={Boolean(error)} onChange={setPhone} onFocus={handleFocus} />
          {error && <span className={styles['error']}>{error}</span>}
        </div>
        <OnboardingTooltip
          open={openTooltip}
          content="Никаких звонков! Выберите лучшие предложение. Только после этого банк свяжется с вами."
          placement="bottom"
          theme="black"
          onClose={closeTooltip}
        >
          <div className={styles['button']}>
            <Button fullWidth size="L" loading={loading} onClick={submitPhone}>
              Продолжить
            </Button>
          </div>
        </OnboardingTooltip>
      </div>
      <div className={styles['footer']} onClick={openModal}>
        При входе, вы принимаете условия{' '}
        <span className={styles['agreement-link']}>Пользовательского&nbsp;соглашения.</span>
      </div>
    </div>
  );
};
